import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./posthog";
import "./gtag";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Page404 } from "./pages/page404";
import { PreviewTemplate } from "./pages/preview-template";
import SignupWizard from "./pages/signup-wizard";

// Montserrat is the Cinch design-system font (loaded in public/index.html). Set
// it app-wide so MUI components match the design instead of the Roboto/Arial default.
const theme = createTheme({ typography: { fontFamily: '"Montserrat","Helvetica","Arial",sans-serif' } });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
        <Route
          path="/preview-template/:inviteId/:password"
          element={<PreviewTemplate />}
        />
        <Route path="/signup" element={<SignupWizard />} />
        <Route path="*" element={<Page404 />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);
